<template>
  <!--
    	作者：zct
    	时间：2021-10-08
    	描述：会员-添加会员
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="80px">
      <!--添加会员-->
      <div class="common-form">编辑用户</div>

      <el-form-item label="真实姓名" prop="real_name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.real_name" placeholder="请输入真实姓名" class="max-w460"></el-input>
      </el-form-item>
      <!-- <el-form-item label="会员logo">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload">选择图片</el-button>
          <div v-if="form.logo_image_id!=''" class="img">
            <img :src="file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item> -->
      <el-form-item label="手机号码" prop="mobile" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.mobile" placeholder="请输入会员手机号码" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="登录密码" prop="password" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.password" placeholder="请输入登录密码" type="password" class="max-w460"></el-input>
        <div class="tips">注：默认密码为123456</div>
      </el-form-item>
      <el-form-item label="性别"  prop="gender" :rules="[{required: true,message: ' '}]">
        <el-radio-group v-model="form.gender">
          <el-radio :label="1">男</el-radio>
          <el-radio :label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="所属单位" prop="unit_id" :rules="[{required: true,message: ' '}]">
        <el-select v-model="form.unit_id"  filterable placeholder="请选择" @change="initUnit">
          <el-option
            v-for="item in unit"
            :key="item.unit_id"
            :label="item.unit_name"
            :value="item.unit_id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属团队" prop="unit_group_id" v-if="form.unit_id != ''">
        <el-select v-model="form.unit_group_id"  filterable placeholder="请选择">
          <el-option
            v-for="item in group"
            :key="item.unit_group_id"
            :label="item.unit_group_name"
            :value="item.unit_group_id">
          </el-option>
        </el-select>
      </el-form-item>




      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
  import Getpoint from '@/components/map/Getpoint.vue';
  import UserApi from '@/api/user.js';
  import Upload from '@/components/file/Upload';
  export default {
    components: {
      /*腾讯地图拾取器*/
      Getpoint,
      Upload
    },
    data() {
      return {
        /*切换菜单*/
        // activeIndex: '1',
        /*form表单数据*/
        form: {
          real_name: '',
          mobile: '',
          gender: 1,
          unit_id: '',
          unit_group_id: '',
          password:'123456',
        },
        file_path: '',
        /*省市区*/
        areaList: [],

        /*是否上传图片*/
        isupload: false,
        loading: false,
        unit:[],
        group:[],
      };
    },
    created() {
      /*引用的select_region 初始化*/
      this.getData();
    },

    methods: {
      getData(){
        let self = this;
        UserApi.toAddUser({}, true)
          .then(res => {
            self.unit = res.data.unit;

          })
          .catch(error => {

          });
      },
      /*添加用户*/
      onSubmit() {
        let self = this;
        let form = self.form;
        if (form.password.length < 6) {
          self.$message({
            message: '密码不能小于六位数！',
            type: 'warning'
          });
          return;
        }
        if (form.mobile.length != 11) {
          self.$message({
            message: '手机号码要11位数！',
            type: 'warning'
          });
          return;
        }
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            UserApi.adduser(form, true)
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '恭喜你，添加成功',
                    type: 'success'
                  });
                  self.$router.push('/user/user/index');
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });


      },
      initUnit(e){
        this.form.unit_group_id = '';
        this.unit.forEach(item=>{
          if(item.unit_id == e){
            this.group = item.group
          }
        })
        console.log(e)
      },
      /*初始化城市id*/
      initCity() {
        this.form.city_id = ''
      },

      /*初始化区id*/
      initRegion() {
        this.form.region_id = ''
      },

      /*获取经纬度*/
      getMapdataFunc(e) {
        this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
      },

      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.file_path = e[0].file_path;
          this.form.logo_image_id = e[0].file_id;
        }
        this.isupload = false;
      },

      /*选择的地址*/
      choseFunc(e){
        this.form.coordinate=e.location.lat+','+e.location.lng;
        this.form.address=e.address;

      },

      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      }

    }

  };
</script>

<style lang="scss" scoped>
  .basic-setting-content {}

  .product-add {
    padding-bottom: 50px;
  }

  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/user/user/add.vue